import { render, staticRenderFns } from "./IllustrationMosaic.vue?vue&type=template&id=80faed58&scoped=true"
import script from "./IllustrationMosaic.vue?vue&type=script&lang=js"
export * from "./IllustrationMosaic.vue?vue&type=script&lang=js"
import style0 from "./IllustrationMosaic.vue?vue&type=style&index=0&id=80faed58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80faed58",
  null
  
)

export default component.exports